import type { FinPaymentRequestRow } from '@shared/api';

/** Сумма к утверждению, пока её не правили в строке: утверждённая, если есть, иначе сумма
 *  заявки — не больше запрошенной. */
export function defaultApprovedAmount(
  req: Pick<FinPaymentRequestRow, 'amount' | 'approved_amount' | 'requested_amount'>,
): number {
  const requested = req.requested_amount || req.amount;
  return Math.min(requested, req.approved_amount > 0 ? req.approved_amount : req.amount);
}

export type { PipelineMetrics, PipelineStage } from './pipeline';

/** Шаги конвейера — по кодам `PipelineStage`. */
export const STAGE_LABELS: Record<string, string> = {
  all: 'Все заявки',
  forming: '1. На проверке',
  gates_passed: '2. Для Гендиректора',
  approved: '3. Утверждено',
  in_bank: '4. В 1С / в банке',
  executed: '5. Факт по выписке',
};
